export type DevicesViewType = "cards" | "map" | "table";

export const DEVICES_VIEW_STORAGE_KEY = "davey-devices-view-preference";

const VALID_VIEWS: DevicesViewType[] = ["cards", "map", "table"];

export function readDevicesViewPreference(
  fallback: DevicesViewType = "cards",
): DevicesViewType {
  try {
    const stored = localStorage.getItem(DEVICES_VIEW_STORAGE_KEY);
    if (stored && VALID_VIEWS.includes(stored as DevicesViewType)) {
      return stored as DevicesViewType;
    }
  } catch {
    // ignore storage errors
  }
  return fallback;
}

export function writeDevicesViewPreference(view: DevicesViewType): void {
  try {
    localStorage.setItem(DEVICES_VIEW_STORAGE_KEY, view);
  } catch {
    // ignore storage errors
  }
}
